import React, { FC } from "react";

const style: React.CSSProperties = {
    height: "auto",
    verticalAlign: "middle",
    width: 20
};

const AlexaIcon: FC = () => {
    return <img style={style} src="/img/alexa-logo.svg" alt="Amazon Alexa Logo" />;
};

export { AlexaIcon };
